module.exports = __webpack_public_path__ + "img/top-bar.164f81bb.png";